// extracted by mini-css-extract-plugin
export var originalPrice = "_uq-0";